<template>
  <article class="page">
    <header class="banner">
      <div class="banner-content">
        <div class="banner-text">
          <p class="banner-title">互联场地专家评标登录工作台</p>
          <p class="banner-desc">助力建设全国统一大市场，优化市场营商环境</p>
        </div>
        <img src="../../assets/img/banner2/icon-login.png" alt="" class="banner-img">
      </div>
    </header>
    <section class="box">
      <mytitle title="对接实施具体步骤" style="margin-top: 64px;"></mytitle>
      <div class="stepbox">
        <template v-for="(item, index) in stepInfo">
          <div class="stepitembg">
            <template v-if="item.title">
              <div class="overtop"></div>
              <contactUs v-show="item.showContact"></contactUs>
              <div class="stepitem">
                  <div class="step-top">
                      <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">
                  </div>
                  <div class="stepindex">{{ index + 1 }}</div>
                  <div class="stepico">
                      <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                  </div>
                  <div class="stepTitle" v-html="item.title"></div>
                  <div class="stepText" v-html="item.description"></div>
                  <template v-if="item.url">
                    <div style="display: flex;margin-top: 44px;justify-content: space-evenly;padding: 0 10px;">
                      <el-button class="btn2" @click="preview(item.url)">预览</el-button>
                      <el-button type="primary" class="btn1" @click="download(item.url)">下载</el-button>
                    </div>
                  </template>
                  <template v-if="item.contactUs">
                    <div style="display: flex;margin-top: 34px;justify-content: space-evenly;padding: 0 10px;">
                      <el-button class="btn2" style="width: 356px;" @mouseover="item.showContact = true" @mouseleave="item.showContact = false">联系我们</el-button>
                    </div>
                  </template>
              </div>
            </template>
          </div>
        </template>
      </div>
    </section>
    <section class="select-box">
      <div class="select-top">
          <mytitle title="互联场地专家评标登录工作台目录" color="white" style="margin-top: 64px;"></mytitle>
          <div class="search">
              <el-input v-model="platformParms.platformName" placeholder="请输入场地专家评标登录工作台名称搜索"class="paperview-input-text" />
              <el-button type="primary" class="searchbtn">搜索</el-button>
          </div>
      </div>
      <div class="content">
        <div class="platformtype-title">省级（{{ platformList.length }}）</div>
        <div class="content-box">
          <div v-for="item in platformList" @mouseenter="item.isHovered = true" @mouseleave="item.isHovered = false">
            <div v-if="!item.isHovered" class="province-item">
              <img :src=item.firstPlatform.platformLogo alt="" style="width: 130px; height: 130px;"/>
              <img src="../../assets/img/tradingSystem/new-tag.png" alt="" class="new-tag" v-if="item.isNew"/>
            </div>
            <div v-if="item.isHovered" class="hover-content">
              <div class="hover-logo">
                <img :src=item.firstPlatform.platformLogo alt="">
              </div>
              <div class="hover-text">
                <p>{{ item.firstPlatform.platformContactName }}</p>
                <p>{{ item.firstPlatform.platformContactPhone }}</p>
              </div>
              <div class="time">
                <img src="../../assets/img/bidEvaluationTools/time.png" alt="" style="width: 14px;height: 14px;"/>
                <span class="info-text3" style="margin-left: 3px;">{{ item.createTime }}</span>
              </div>
            </div>
          </div>
          <div v-for="n in noreginList" class="province-item">{{ n.title }}</div>
        </div>
        <div class="platformtype-title" style="margin-top: 16px;">地级市（{{ total }}）</div>
        <div v-for="(item, index) in cityList" :key="index">
          <div class="municipality-title">
            <div class="municipality-name">{{ item.title }}</div>
            <div class="municipality-total"> 共加入 {{ item.platformList.length }} 家</div>
          </div>
          <div class="municipality-content">
            <div class="municipality-inner">
              <div v-for="n in 6" class="province-item">
                <img src='../../assets/img/tradingSystem/npapp.png' alt="" class="noapp" style="border:none">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </article>
</template>

<script lang='ts' setup>
import { nextTick, onMounted, ref } from 'vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'
import { reginList } from '../../const/index'
import { useRoute } from 'vue-router'

const route = useRoute()

onMounted(async () => {
  await nextTick(); // 等待 DOM 更新
  if (route.query.bottom) {
    // 滚动到距离页面顶部800px的位置  
    window.scrollTo({
      top: 900,
      behavior: 'smooth' // 可选，用于平滑滚动  
    });
  } else {
    window.scrollTo(0, 0);
  }
})

const stepInfo = ref([
  {
    title: '阅读接入指南',
    description: '预览、下载《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》',
    url: 'T04远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南_20250605_1600.pdf',
  },
  {
    title: '远程异地评标<br>目录服务组件集成对接',
    description: '运营机构联系中国招标投标公共服务平台运维实施人员集成对接远程异地评标共享目录服务组件',
    url: 'T04远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南_20250605_1600.pdf',
  },
  {
    title: '与跨省远程异地目录服务<br/>组件共同联调测试',
    description: '与跨省远程异地目录服务组件共同联调测试相关接口',
    contactUs: true,
    showContact: false,
  },
  {
    title: '公开测试承诺',
    description: '与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目交易中心场所自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入场地专家评标登录工作台互联目录',
  }
])

const preview = (url: string) => {
  window._czc.push(['_trackEvent', '场地专家评标', '预览', '场地专家评标登录工作台接入指南预览'])
  window.open(url, '_blank')
}

const download = (url: string) => {
  window._czc.push(['_trackEvent', '场地专家评标', '下载', '场地专家评标登录工作台接入指南预览'])
  const link = document.createElement('a')
  link.href = url
  link.download = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const platformParms = ref({
  platformName: '',
})

//省级
let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    isHovered: false,
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: "李炜",
      platformContactPhone: "13886032676",
      platformLogo: require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: "2025/3/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
])

const noreginList = ref<any[]>([])
noreginList.value = reginList.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);

const cityList = ref<any[]>([])
const total = ref(0)
cityList.value = reginList.map((item) => {
  return {
    ...item,
    platformList: []
  }
})
</script>

<style lang="scss" scoped>
@import "../../assets/css/step.scss";

.page {
  .banner {
    width: 100%;
    height: 577px;
    min-width: 1200px;
    background: url('../../assets/img/banner2/registration-bg.png') no-repeat center center/cover;
    padding-top: 116px;
    box-sizing: border-box;
    &-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
    }
    &-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &-title {
      font-size: 36px;
      font-weight: 600;
      line-height: 70px;
      color: #323335;
    }
    &-desc {
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      color: #64666B;
    }
    &-img {
      height: 413px;
      margin-top: 40px;
      margin-right: -124px;
    }
  }
  .box {
    height: 620px;
    padding: 1px 0 0;
    .stepitem:hover {
      height: 320px !important;
    }
  }
  .select-box {
    margin-bottom: 40px;
    .select-top {
      width: 100%;
      height: 311px;
      background: url('../../assets/img/banner/search.webp') no-repeat center center;
      background-size: 100% 100%;
      padding: 1px;
      box-sizing: border-box;

      .search {
          width: 600px;
          margin: 0 auto;
          display: flex;
          height: 42px;
          background: #fff;
          align-items: center;
          border-radius: 4px;
          padding: 0 3px 0 10px;
          margin-top: 48px;
      }
      .searchbtn {
        background-color: #3461FF;
        width: 120px;
        font-size: 14px;
        height: 32px;
        border: none;
      }
      :deep(.el-input__wrapper) {
        box-shadow: none;
        border: none !important;
      }
      .paperview-input-text {
        font-size: 14px;
        height: 32px
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      border-radius: 4px;
      background-color: #FFFFFF;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);
      margin-top: -40px;
      padding: 0 24px 32px 24px;
      box-sizing: border-box;
      .platformtype-title {
        height: 48px;
        color: #000;
        font-size: 20px;
        font-weight: 600;
        line-height: 48px;
        border-bottom: 1px solid #EBEBED;
      }
      .content-box {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
      .province-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 267px;
        height: 166px;
        border-radius: 8px;
        margin-top: 24px;
        border: 1px solid #EBEBED;
        color: #BFC1C5;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        line-height: 28px;
        cursor: pointer;
        .new-tag {
          position: absolute;
          top: 0;
          right: 0;
          width: 90px;
          height: 22px;
        }
        img {
          width: 90px;
          height: 90px;
        }
      }
      .municipality-title {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #EBEBED;
        padding: 16px 48px 0 24px;
        box-sizing: border-box;
        align-items: center;
        .municipality-name {
          color: #323335;
          font-size: 16px;
          font-weight: 400;
          line-height: 36px;
        }
        .municipality-total {
          color: #4B5B76;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
        }
      }
      .municipality-content {
        overflow-x: clip;
        .municipality-inner {
          display: flex;
          .province-item {
            flex-shrink: 0;
            width: 267px;
            height: 204px;
            margin: 14px 24px 0 0;
          }
        }
      }
    }
  }
  .btn1 {
    background-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: none;
  }
  .btn2 {
    color: #3461FF;
    border-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: 1px solid #3461FF;
  }
  .btn2:hover {
    color: #fff;
    background-color: #3461FF;
    border-color: #3461FF;
  }
  .hover-content {
    width: 276px;
    height: 190px;
    padding: 20px 15px;
    box-sizing: border-box;
    border-radius: var(--Radius-Border-radius-4, 8px);
    border: var(--Radius-Border-radius-2, 2px) solid var(--Text-Text-4, #f4f4f5);
    background: #fff;
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
    .hover-logo {
      margin: 5px auto;
      text-align: center;
      img {
        height: 80px;
      }
    }
    .hover-text {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      p {
        color: var(--Text-neutral-10, #64666B);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        height: 21px;
        padding: 0px 7px;
        border-radius: var(--Radius-Border-radius-2, 2px);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Branding-Blue-6, #3461FF);

        overflow: hidden;
        /* 保持文本在一行内 */
        white-space: nowrap;
        /* 文本超出时显示省略号 */
        text-overflow: ellipsis;
      }
        
    }
    .time {
      display: flex;
      align-items: center;
      margin-top: 10px;
      color: var(--Text-neutral-9, #969AA0);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>